import React from 'react';
import { Story } from '../../../../models/Story';
import StoryBookmark from '../BookmarkItems/StoryBookmark';
import { BookmarkListContainer } from '../bookmarkStyles';

type StoryBookmarkProps = {
	stories: Story[];
};
const StoryBookmarks: React.FC<StoryBookmarkProps> = ({ stories }) => {
	return (
		<BookmarkListContainer>
			{stories.map((story) => {
				return <StoryBookmark key={story.id} story={story} />;
			})}
		</BookmarkListContainer>
	);
};

export default StoryBookmarks;
